<template>
  <el-dialog :visible.sync="visible_v" title="导出证明文件"
             width="800px"
             @close="
      () => {
        $emit('cancel')
      }
    ">
    <Form ref="addEvaluation" :label-width="120" :model="formCustom" :rules="ruleValidate">
      <Form-item label="居留许可办理：" prop="evaluationItem">
        <el-checkbox-group v-model="formCustom.evaluationItem" :disabled="select || isupload">
          <el-checkbox label="代办委托书-成年"></el-checkbox>
          <el-checkbox label="代办委托书-未成年"></el-checkbox>
          <el-checkbox label="工作类居留证件申请报告"></el-checkbox>
          <el-checkbox label="情况说明（宁波市出入境）"></el-checkbox>
          <el-checkbox label="情况说明（鄞州出入境）"></el-checkbox>
          <el-checkbox label="任职期间综合评价表"></el-checkbox>
          <el-checkbox label="涉外单位承诺书（宁波市出入境）"></el-checkbox>
          <el-checkbox label="涉外单位承诺书（鄞州出入境）"></el-checkbox>
          <el-checkbox label="私人事务团聚类居留证件申请报告"></el-checkbox>
          <el-checkbox label="提前发起情况说明"></el-checkbox>
          <el-checkbox label="外国人签证证件申请审批表-随行家属"></el-checkbox>
          <el-checkbox label="外国人签证证件申请审批表-员工"></el-checkbox>
          <el-checkbox label="无违法犯罪记录承诺书"></el-checkbox>
        </el-checkbox-group>
      </Form-item>
      <Form-item label="工作许可办理：" prop="evaluationItem">
        <el-checkbox-group v-model="formCustom.evaluationItem" :disabled="select || isupload">
          <el-checkbox label="保险承诺书"></el-checkbox>
          <el-checkbox label="保险到期续保承诺书"></el-checkbox>
          <el-checkbox label="岗位职责说明"></el-checkbox>
          <el-checkbox label="工作资历证明"></el-checkbox>
          <el-checkbox label="离职证明"></el-checkbox>
          <el-checkbox label="情况说明-仅抬头+个人信息"></el-checkbox>
          <el-checkbox label="任职证明"></el-checkbox>
          <el-checkbox label="入境体检承诺函-家属"></el-checkbox>
          <el-checkbox label="入境体检承诺函-员工"></el-checkbox>
          <el-checkbox label="薪资情况说明"></el-checkbox>
          <el-checkbox label="姓名情况说明"></el-checkbox>
          <el-checkbox label="邀请函-高端人才"></el-checkbox>
          <el-checkbox label="用人单位材料真实性承诺书"></el-checkbox>
          <el-checkbox label="邮寄委托书"></el-checkbox>
          <el-checkbox label="职务情况说明"></el-checkbox>
        </el-checkbox-group>
      </Form-item>
    </Form>
    <Button :loading="addloading" style="margin-left: 350px;" type="primary" @click="add">
      导出
    </Button>
  </el-dialog>
</template>
<script>
import permissionList from "@/libs/handlePermission.ts";
import {employeeList, organizationTreeAll} from '@/api/public'
import {companyEvaluationAdd, companyEvaluationPut} from '@/api/evaluation'
import {countryArr} from "./country";

export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    model: {
      type: Object,
      default: () => null
    },
    isupload: {
      type: Boolean,
      required: false
    },
    select: {
      type: Boolean,
      required: false
    },
  },
  watch: {
    visible(v) {
      console.log(v)
      this.visible_v = v
      if (v) {
        this.init()
      }
    }
  },
  name: "company",
  data() {
    return {
      columns: [
        {type: "index", title: "序号", align: "center"},
        {title: "家属姓名", key: "companyName", align: "center"},
        {title: "国籍", key: "deptName", align: "center"},
        {title: "家属类型", key: "employeeRealName", align: "center"},
        {title: "出生年月日", key: "employeePositionName", align: "center"},
        {title: "护照号码", key: "evaluationItem", align: "center"},
        {title: "护照到期日期", slot: "leaveUrl", key: "leaveUrl", align: "center"},
        {title: "居留许可号码", key: "evaluationRole", align: "center"},
        {title: "居留许可签发日期", key: "auditStatus", align: "center", slot: "auditStatus"},
        {title: "居留许可到期日期", align: "center", fixed: "right"},
        {title: "操作", slot: "action", align: "center", fixed: "right"},
      ],
      tableData: '',
      loading: false,
      countryArr: countryArr,
      addloading: false,
      defaultValue: [],
      isShow: false,
      organization: '',
      formCustom: {
        evaluationItem: [],
        evaluationRole: [],
        organizationIdList: [],
        evaluationEmployeeIds: [],
        evaluationCategory: ''
      },
      visible_v: false,
      BaseUrl: process.env.VUE_APP_BASE_URL,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("getToken"),
      },
      value: 1,
      options: [],
      organizationList: [], // 组织机构列表
      ruleValidate: {
        evaluationCategory: [
          {required: true, message: '请填写', trigger: 'blur'}
        ]
      }
    }
  },
  components: {},
  mounted() {
    const list = JSON.parse(localStorage.getItem("routerList"))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    let token = localStorage.getItem('getToken')
    let userString = decodeURIComponent((window.atob(token.split('.')[1].replace(/-/g, "+").replace(/_/g, "/"))))
    let user = JSON.parse(userString);
    this.init()
    this.roleType = user.roleType;
  },
  methods: {
    init() {
      organizationTreeAll().then((response) => {
        this.organizationList = response.data.data
        console.log(this.isupload)
        if (this.isupload) {
          console.log(this.model)
          this.formCustom.evaluationCategory = this.model.evaluationCategory
          this.formCustom.evaluationItem = this.model.evaluationItem.split(',')
          this.formCustom.evaluationRole = this.model.evaluationRole.split(',')
          let a = []
          a.push(this.model.groupId)
          if (this.model.companyId) {
            this.organization = this.model.groupName + '-' + this.model.companyName
            a.push(this.model.companyId)
          }
          if (this.model.deptId) {
            this.organization = this.model.groupName + '-' + this.model.companyName + '-' + this.model.deptName
            a.push(this.model.deptId)
          } else {
            this.organization = this.model.groupName
          }
          const pramas = {
            organizationId: a[a.length - 1]
          };
          this.formCustom.evaluationEmployeeIds = []
          if (this.model.evaluationEmployeeIds) {
            this.model.evaluationEmployeeIds.split(',').forEach(e => {
              this.formCustom.evaluationEmployeeIds.push(e * 1)
            })
          }
          employeeList(pramas).then(res => {
            this.options = res.data.data
            if (this.model.evaluationEmployeeIds && this.model.evaluationEmployeeIds.split(',').length == this.options.length) {
              this.value = 1
            } else {
              this.value = 2
            }
          })
        } else {
          this.formCustom = {
            evaluationItem: [],
            evaluationRole: [],
            organizationIdList: [],
            evaluationEmployeeIds: [],
            evaluationCategory: ''
          }
        }
      })
      this.isShow = false;
      // 定时器重新载入组件就可以触发组件拉取数据
      setTimeout(() => {
        this.isShow = true;
      }, 0);
    },
    getOrganizationIdList(val, data) {
      if (data.length !== 0) {
        console.log(this.formCustom.organizationIdList)
        this.formCustom.organizationIdList = data.map(item => item.id)
        console.log(this.formCustom.organizationIdList)
        const pramas = {
          organizationId: this.formCustom.organizationIdList[this.formCustom.organizationIdList.length - 1]
        };
        employeeList(pramas).then(res => {
          this.options = res.data.data
          this.formCustom.evaluationEmployeeIds = []
        })
      }
    },
    add() {
      this.addloading = true
      if (this.isupload) {
        let params = {}
        if (this.formCustom.evaluationCategory) {
          params.evaluationCategory = this.formCustom.evaluationCategory
        } else {
          this.$message.error("请先填写考评类目");
          this.addloading = false
          return
        }
        if (this.value == 1) {
          let list = []
          this.options.forEach(e => {
            list.push(e.employeeId)
          })
          params.evaluationEmployeeIds = list.join(",")
        } else if (this.formCustom.evaluationEmployeeIds.length) {
          let list = []
          this.formCustom.evaluationEmployeeIds.forEach(e => {
            list.push(e)
          })
          params.evaluationEmployeeIds = list.join(",")
        } else {
          this.$message.error("请先选择受考评对象");
          this.addloading = false
          return
        }
        params.companyEvaluationId = this.model.companyEvaluationId
        companyEvaluationPut(params).then(res => {
          this.addloading = false
          if (res.data.success) {
            this.$emit('successadd')
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(error => {
          this.addloading = false
          this.$message.error(error.response.data.msg);
        })
      } else {
        let pramas = {}
        if (this.formCustom.evaluationCategory) {
          pramas.evaluationCategory = this.formCustom.evaluationCategory
        } else {
          this.$message.error("请先填写考评类目");
          this.addloading = false
          return
        }
        if (this.formCustom.evaluationItem.length) {
          pramas.evaluationItem = this.formCustom.evaluationItem.join(",")
        } else {
          this.$message.error("请先选择考评表");
          this.addloading = false
          return
        }
        if (this.formCustom.evaluationRole.length) {
          pramas.evaluationRole = this.formCustom.evaluationRole.join(",")
        } else {
          this.$message.error("请先选择考评员");
          this.addloading = false
          return
        }
        if (this.formCustom.organizationIdList.length == 1) {
          pramas.organizationId = this.formCustom.organizationIdList[0]
        } else if (this.formCustom.organizationIdList.length == 2) {
          pramas.organizationId = this.formCustom.organizationIdList[1]
        } else if (this.formCustom.organizationIdList.length == 3) {
          pramas.organizationId = this.formCustom.organizationIdList[2]
        } else {
          this.$message.error("请先选择考评范围");
          this.addloading = false
          return
        }
        if (this.value == 1) {
          let list = []
          this.options.forEach(e => {
            list.push(e.employeeId)
          })
          pramas.evaluationEmployeeIds = list.join(",")
        } else if (this.formCustom.evaluationEmployeeIds.length) {
          let list = []
          this.formCustom.evaluationEmployeeIds.forEach(e => {
            list.push(e)
          })
          pramas.evaluationEmployeeIds = list.join(",")
        } else {
          this.$message.error("请先选择受考评对象");
          this.addloading = false
          return
        }
        companyEvaluationAdd(pramas).then(res => {
          this.addloading = false
          if (res.data.success) {
            this.$emit('successadd')
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        })
      }
    }
  }
}
</script>
